import React, { useMemo } from "react";
import { Chip, Stack, Typography } from "@mui/material";

import { HubTableTemplate } from "../../components";
import { useGetQuotes } from "../../hooks/react-query/useSalesData";
import { QUOTE_STAGE_LABELS } from "../../constants/salesStages";

import SalesContextMenu from "../../containers/SalesKanban/SalesContextMenu";
import SalesEmpty from "../../containers/SalesKanban/SalesEmpty";

const items = [
  { id: "partName", label: "Part" },
  { id: "stage", label: "Stage" },
  { id: "partsPerTree", label: "Parts/Tree" },
  { id: "material", label: "Alloy" },
  { id: "price", label: "Price" },
  { id: "createdAt", label: "Created" },
];

const keys = [
  {
    value: "partName",
    CustomComponent: ({ item }) => (
      <Stack direction="row" gap="10px" alignItems="center">
        <Typography variant="caption" fontSize={12} fontWeight={500}>
          {item?.part?.partName || item?.partName || "—"}
        </Typography>
        {(item?.part?.partNumber || item?.partNumber) && (
          <Typography variant="caption" fontSize={10} color="text.secondary">
            {item?.part?.partNumber || item?.partNumber}
          </Typography>
        )}
      </Stack>
    ),
  },
  {
    value: "stage",
    CustomComponent: ({ item }) => {
      const stage = QUOTE_STAGE_LABELS.find((s) => s.id === item?.stage);
      return stage ? (
        <Chip
          label={stage.label}
          variant="colorTag"
          flow={stage.flow}
          size="small"
          sx={{ fontSize: 10, margin: "-2px 0px" }}
        />
      ) : null;
    },
  },
  { value: "partsPerTree", defaultValue: 1 },
  { value: "material.name", defaultValue: "—" },
  { value: "price", isCurrency: true, defaultValue: 0 },
  { value: "createdAt", isDate: true },
];

const QuoteTableContextMenu = ({ item }) => (
  <SalesContextMenu itemId={item?.id} type="quote" />
);

export const SalesQuotesTable = () => {
  const { data, isLoading } = useGetQuotes();

  const rows = useMemo(
    () => (data || []).flatMap((col) => col.elements),
    [data],
  );

  if (!isLoading && !rows.length) return <SalesEmpty type="quote" />;

  return (
    <Stack padding="15px" overflow="auto" flex={1}>
      <HubTableTemplate
        id="SalesQuotesTable"
        headerProps={{ items, includeEnd: true }}
        bodyProps={{ items: rows, keys, ContextMenu: QuoteTableContextMenu }}
        isLoading={isLoading}
      />
    </Stack>
  );
};

export default SalesQuotesTable;
